/* import __COLOCATED_TEMPLATE__ from './image-loader.hbs'; */
import { on } from '@ember/object/evented';
import { htmlSafe } from '@ember/template';
import { computed, observer } from '@ember/object';
import { notEmpty } from '@ember/object/computed';
import Component from '@ember/component';

/**
 * @returns {boolean}
 */
const emptyFunc = () => false;

/**
 * @returns {{ unregister: undefined, internalSrc: string }}
 */
const defaultLoadingProps = () => ({ unregister: undefined, internalSrc: '' });

/**
 * @param {string} internalSrc
 * @returns {{ unregister: undefined, internalSrc: string }}
 */
const loadedProps = (internalSrc) => ({ unregister: undefined, internalSrc });

/**
 * @param {function} unregister
 * @returns {{ unregister: function, internalSrc: string }}
 */
const loadingProps = (unregister) => ({ unregister, internalSrc: '' });

/**
 * @class
 */
export default Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @param {string} */
  src: '',

  /** @param {string} */
  alt: '',

  /** @param {function} */
  onLoad: undefined,

  /** @param {function} */
  onError: undefined,

  /** @type {function} */
  unregister: undefined,

  /** @type {boolean} */
  loading: notEmpty('unregister'),

  /** @type {boolean} */
  isBackgroundImage: false,

  /** @type {Ember.String.htmlSafe} */
  _backgroundImageStyle: computed('internalSrc', function () {
    return htmlSafe(`background-image: url('${this.get('internalSrc')}')`);
  }),

  /** @type {string} */
  internalSrc: '',

  /** @type {function} */
  internalSrcObserver: on('init', observer('src', function() {
    this.execute('unregister');

    const src = this.get('src');

    if (!src) {
      this.setProperties(defaultLoadingProps());
      return;
    }

    const onLoad = () => {
      this.setProperties(loadedProps(src));
      this.execute('onLoad');
    };

    const onError = () => {
      this.setProperties(defaultLoadingProps());
      this.execute('onError');
    };

    const image = new Image();
    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    image.src = src;

    const unregister = () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };

    this.setProperties(loadingProps(unregister));
  })),

  /**
   * @param {string} prop
   */
  execute(prop) {
    const func = this.get(prop);

    if (func) {
      func();
    }
  },

  /** @inheritDoc */
  willDestroy() {
    this._super(...arguments);
    this.execute('unregister');
    this.set('unregister', undefined);
  },
});
